module.exports = __webpack_public_path__ + "img/kemoclub.bfeb8151.png";